<template>
  <section class="section">
    <div class="container" style="margin-top: -30px;">
      <div class="columns" >
        <div class="column">
          <span class="title24"> ລາຍການລົງທະບຽນຜ່ານການສະແກນ QR </span>
        </div>
          
      </div>
      <b-tabs v-model="activeTab" >
        <b-tab-item label="ລາຍການງານ/ Event" >
          <table class="table is-fullwidth is-narrow is-small" >
            <thead>
              <tr>
                <th class="has-text-left " width="2%">
                  ລຳດັບ
                </th>
                <th class="has-text-left " width="40%">
                  ຊື່ງານ/ Event
                </th>
                
                <th class="has-text-centered " width="20%">
                  ລາຍລະອຽດ
                </th>
                
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, index) in eventList"
                :key="data.ID"
              >
                <td class="has-text-left ">
                  {{ index +1 }}
                </td>
                <td class="has-text-left ">
                  {{ data.NAME }}&nbsp;<span v-if="data.ISPAY==1" class="red14bold">(ເສຍເງິນ)</span>    
                </td> 
                <td class="has-text-centered ">
                  <b-field>
                    <b-button class="btn-group-margin is-fullwidth"
                        type="is-info"  
                        size="is-small"
                        @click="getEventDetail(data, data.ISPAY)"
                        >  <span >ເບິ່ງ QR</span>
                    </b-button>
                  </b-field>
                    
                 
              </td> 
                
              </tr>
            </tbody>
            
          </table>
        </b-tab-item>
        <b-tab-item label="ລາຍລະອຽດ" >
          <div class="columns" v-if="selectedEventName">
            <div class="column">
              <b-field>
                <span  class="title16-light" >ໃຊ້ສະແກນ ເພື່ອລົງທະບຽນເຂົ້າຮ່ວມງານ </span>
              </b-field>
              <b-field><span  class="title16">{{ selectedEventName }} </span></b-field>
              <b-field v-if="selectedEventName">
                <img :src="qrCodeUrl" alt="QR Code" />
              </b-field>

              
              
            </div>
              
            
              
          </div>
        </b-tab-item>
        
      </b-tabs>
      

      
    </div>


    
    
    

    
    
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";
// import axios from "axios";


// import { BFormSelect } from 'bootstrap-vue'



export default {
  // components: { Multiselect, BFormSelect},
  // components: { Multiselect },

  props: {
    regno: {
      type: String,
      required: false, // Make it optional to support both routes
    },
  },
  data() {
    return {
      roleid: null,
      userName: null,

      activeTab: 0,

      selectedSection: null,
      selectionList: [],

      participateList: [],

      eventList: [],

      selectedEventID: null,
      selectedEventName: null, 
      
      

      qrData: null,

      

    };
     
    
  },
  methods: {   
    
    getEventDetail(data, ispay){ 
      
      this.activeTab = 1;
      
      this.selectedEventData = data; 
      this.regsiterByPhoneno = null;
      this.phoneNoEventList = [];
      this.selectedEventName = data.NAME;
      this.selectedEventID = data.ID;
      this.isSearch = 0;
      this.isEditForm = 0;

      if(ispay==1){
        this.qrData = "https://lababiz.com/#/event/registerpay/"+ this.selectedEventID;
      }else{
        this.qrData = "https://lababiz.com/#/event/register/"+ this.selectedEventID;
      }
      
          
      
          
       
      
    },
   
    getEvent() {
      RestAPI.getEvent()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.eventList = res.data.responseData.data.normal;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
 
    

    

  },
  mounted() {
    this.roleid = this.user ? this.user.ROLEID : null;
    this.roleid = 3;
    this.username = this.user.USERNAME;
    this.getEvent(); 
  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    qrCodeUrl() {
      // Use the qrserver API to generate the QR code image URL
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(this.qrData)}`;
    },

    // computed: {

    //   filteredParticipateList() {
    //     return this.participateList.filter((data) =>
    //       data.FULLNAME.toLowerCase().includes(this.searchByFullName.toLowerCase())
    //     );
    //   },

    // },
  
   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.status-3 {
  background-color: #4FC3F7; /* Light blue for status 3 */
  color: white;
}

.status-2 {
  background-color: #B3E5FC; /* Lighter blue for status 2 */
  color: black;
}

.status-0 {
  background-color: #CFD8DC; /* Gray for status 0 */
  color: black;
}

.status-default {
  background-color: transparent; /* Default styling */
  color: inherit;
}

.centered-content {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.card {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;  
  margin-bottom: 0px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.content{
  font-size: 16px;
  margin-left: 5px; 
  margin-right: 5px;
}

.title24{
  font-size: 24px;
  font-weight: bold;
}

.title24-light{
  font-size: 24px;
}

.title20{
  font-size: 20px;
  font-weight: bold;
}

.title20-light{
  font-size: 20px;
}

.title16{
  font-size: 18px;
  font-weight: bold;
}

.title16-light{
  font-size: 18px;
}

.title14{
  font-size: 16px;
  font-weight: bold;
}
.title14-light{
  font-size: 16px;
  font-weight: bold;
}

.title12{
  font-size: 14px;
  font-weight: bold;
}

.title12-light{
  font-size: 14px;
}

.red16bold{
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.red16{
  color: red;
  font-size: 18px;
  
}

.red14bold{
  color: red;
  font-size: 16px;
  font-weight: bold;
}

.red14{
  color: red;
  font-size: 16px;
}

.red12bold{
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.red12{
  color: red;
  font-size: 14px;
}




.container{  
  margin-top: 10px;
}
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-50 {
  flex: 0 0 50%;
}

.column-65 {
  flex: 0 0 65%;
}

.column-35 {
  flex: 0 0 35%;
}

.column-30 {
  flex: 0 0 30%;
}
.column-70 {
  flex: 0 0 70%;
}

.column-20 {
  flex: 0 0 20%;
}
.column-80 {
  flex: 0 0 80%;
}


.asterisk {
  color: red;
}
  
.set-border {
  border: 1px solid #838282;      
}

tbody tr:last-child td {
  border-bottom: 1px solid #000; /* Specifically target the last row's bottom border */
}

.summary-footer {
  page-break-before: always;
}

.modal {  
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
